import {stringPattern, tagMaxLength, tagMinLength } from '../../../utils/form-validations';

export const defaultFields = { service_name: '', key: '', port: '' };
export const activityDefFields = {
  name: '',
  created_date: 0,
};

export const checklistNameSchema = {
  type: 'string',
  minLength: 3,
  maxLength: 30,
};

export const checklistTagsSchema = {
  type: 'object',
  properties: {
    id: { type: 'number' },
    key: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength, pattern: stringPattern },
    value: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength, pattern: stringPattern },
  },
  required: ['key', 'value'],
};

export const activitiesListSchema = {
  type: 'object',
  properties: {
    sequence: { type: 'number' },
    id: { type: 'number' },
    activity_name: { type: 'string', minLength: tagMinLength, maxLength: tagMaxLength, pattern: stringPattern },
  },
  required: ['activity_name'], //'description', 'pre_requisites'
  additionalProperties: true,
};